import React from "react";
import { useDispatch } from "react-redux";
import { Button, Confirm, Icon } from "semantic-ui-react";
import { sendRefund } from "../../../store/actions/superAdminNewRequest";
import "../CsaMedia/CsaMedia.css";

const ConfirmModal = (props) => {
  const dispatch = useDispatch();
  const handleRefund = () => {
    if (props.selectedPlan?.otp === false) {
      dispatch(
        sendRefund(
          props.newUser.id,
          props.newUser.subscription_id,
          "subscription",
          props.newUser.paymentMethod
        )
      );
      props.close();
    }
    if (props.selectedPlan?.otp === true) {
      dispatch(
        sendRefund(
          props.newUser.id,
          props.newUser.transaction_id,
          props.newUser.amount,
          props.newUser.paymentMethod
        )
      );
      props.close();
    }
  };

  return (
    <>
      <Confirm
        open={props.open}
        className="confirm-delete-popup refund-modal"
        content={
          <div className="content">
            <div className="refund-modal-content-1">
              Are you sure you want to reject the subscription plan?
            </div>
            <div className="refund-modal-content-2">
              This process cannot be undone.
            </div>
          </div>
        }
        onCancel={() => {
          props.close();
        }}
        onConfirm={handleRefund}
        cancelButton="Cancel"
        confirmButton={
          <Button
            color="red"
            icon={<Icon name="redo" size="large" />}
            content={
              props.selectedPlan?.otp === true ? "Refund Payment" : "Stop Plan"
            }
            className="refund-btn"
          />
        }
      />
    </>
  );
};

export default ConfirmModal;
